import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { isCrawlerUserAgent } from './loadAdSense';

declare global {
  interface Window {
    adsbygoogle: any[];
  }
}

export default function AutoAdsReloader() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window === 'undefined') return;

    // Skip bots/crawlers
    const ua = navigator.userAgent || '';
    if (isCrawlerUserAgent(ua)) return;

    // Ensure AdSense array exists
    window.adsbygoogle = window.adsbygoogle || [];

    // Defer a bit to allow route content to render before rescan
    const timeoutId = window.setTimeout(() => {
      try {
        // Trigger AdSense to rescan the page (Auto ads)
        window.adsbygoogle.push({});
      } catch (_) {
        // no-op
      }
    }, 300);

    return () => window.clearTimeout(timeoutId);
  }, [location.pathname, location.search, location.hash]);

  return null;
}


